import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/core/components/ui/tooltip";
import { cn } from "@/core/utils/utils";

interface RosterCellValueProps {
  value: string;
  className?: string;
}

export const RosterCellValue = ({ value, className }: RosterCellValueProps) => (
  <Tooltip>
    <TooltipTrigger asChild>
      <span
        className={cn(
          "line-clamp-2 min-w-0 max-w-full whitespace-normal [overflow-wrap:anywhere]",
          className,
        )}
      >
        {value}
      </span>
    </TooltipTrigger>
    <TooltipContent className="whitespace-normal [overflow-wrap:anywhere]">
      {value}
    </TooltipContent>
  </Tooltip>
);
